import ResultsSlider from './ResultsSlider';

export default ResultsSlider;
